import { createContext } from "react";
import { dateAdapterFactory } from "../utils/AdapterFactories";
import { DatePort } from "../helpers/adapters/date/DatePort";

export const DatePortContext = createContext<DatePort>(dateAdapterFactory());
